
import React from 'react';
import { Link } from "react-router-dom";
import { Button } from "@/components/Button";
import { ArrowRight, Headphones } from "lucide-react";

const OneOnOneTab = () => {
  return (
    <div className="mt-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h3 className="text-2xl font-bold mb-3 text-white">1-on-1 AI Training Designed for Legal Professionals</h3>
          <p className="text-lg text-primary mb-5">Personalized. Practical. Powerful.</p>
          
          <p className="text-base text-foreground/80 mb-6">
            Get personalized guidance, expert strategies, and tailored support — so you can master AI confidently and efficiently.
          </p>
          
          <div className="mb-6">
            <h4 className="text-lg font-semibold mb-3 text-white">Why Choose 1-1 Training?</h4>
            <ul className="list-disc list-inside text-foreground/80 space-y-2 pl-2">
              <li>60-minute private Zoom session with an AI expert</li>
              <li>Pre-session questionnaire to tailor training to your goals</li>
              <li>Live walkthroughs, use cases, and Q&A</li>
              <li>Follow-up resource pack based on your session</li>
            </ul>
          </div>
          
          <Link to="/services/training/1-1-pricing">
            <Button variant="primary" hasAnimation={true}>
              Schedule 1-1 Training <ArrowRight className="h-4 w-4 ml-1" />
            </Button>
          </Link>
        </div>
        
        <div className="flex items-center justify-center">
          <div className="p-6 rounded-xl border border-white/10 bg-white/5 backdrop-blur-lg shadow-lg w-full">
            <div className="flex items-center gap-4 mb-4">
              <div className="p-3 rounded-full bg-primary/20">
                <Headphones className="h-6 w-6 text-primary" />
              </div>
              <h4 className="text-xl font-semibold">Accelerate Your Learning</h4>
            </div>
            
            <p className="mb-4 text-foreground/80">
              1-on-1 sessions are the fastest way to gain proficiency with AI tools specific to your practice area. 
              Our experts will guide you through practical applications tailored to your workflow.
            </p>
            
            <Link to="/services/training/1-1-pricing">
              <Button variant="outline" className="w-full border-primary/50 text-primary hover:bg-primary/10">
                View 1-1 Pricing Options
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OneOnOneTab;
